'use client';

import { Button } from '@/components/ui/button';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';
import type { SourceRunStatus } from '@/lib/sources/source-types';
import { ProjectsLoadError } from '@/hooks/useProjectsData';
import { SourceStatusList } from '@/components/shared/SourceStatusList';

interface ProjectsErrorStateProps {
  error: ProjectsLoadError;
  onRetry: () => void;
  sourceStatuses?: SourceRunStatus[];
}

export function ProjectsErrorState({
  error,
  onRetry,
  sourceStatuses,
}: ProjectsErrorStateProps) {
  return (
    <div className="p-4 lg:p-6">
      <div className="border rounded-lg bg-card p-8 md:p-12 max-w-2xl mx-auto">
        <div className="text-center mb-6">
          <IconAlertTriangle className="size-12 text-destructive mx-auto mb-4" />
          <p className="text-lg font-semibold mb-1">{error.summary}</p>
          <p className="text-sm text-muted-foreground">
            Some sources may be unavailable.
          </p>
        </div>

        <SourceStatusList sourceStatuses={sourceStatuses} />

        {/* Actions */}
        <div className="flex items-center justify-center gap-3">
          <Button onClick={onRetry}>
            <IconRefresh className="size-4 mr-1.5" />
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
}
